<template>
  <div class="my-4 md:my-6">
    <div class="">
    <button @click="scrollTo(buttonHref)"
      class="flex items-center px-12 py-3 mx-auto text-base rounded-full md:text-xl md:px-24 lg:py-4 font-ww-medium btn-red gap-x-2">
      {{ buttonText }}
    </button>
  </div>

  <div class="mt-2 text-base text-center text-black font-ww-regular">
    {{ descriptionText }}
  </div>
  </div>
</template>

<script setup>
const props = defineProps({
  buttonHref: {
    type: String,
    default: 'products',
  },
  buttonText: {
    type: String,
    default: 'Save 47% Now',
  },
  descriptionText: {
    type: String,
    default: 'Limited supplies available. Special discount available today.',
  }
});

defineBuilderComponent({
  friendlyName: 'CTA Button with Text',
  inputs: [
    {
      name: 'buttonHref',
      type: 'text',
      friendlyName: 'Button Link',
      defaultValue: 'products',
      helperText: 'The element ID to scroll to when button is clicked'
    },
    {
      name: 'buttonText',
      type: 'text',
      friendlyName: 'Button Text',
      defaultValue: 'Save 47% Now',
      helperText: 'Text displayed on the button'
    },
    {
      name: 'descriptionText',
      type: 'text',
      friendlyName: 'Description Text',
      defaultValue: 'Limited supplies available. Special discount available today.',
      helperText: 'Description text shown below the button'
    }
  ],
});
</script>